<template>
  <div>
    <v-form>
      <gg-text-field
        disabled
        label="Current Email"
        hide-details
        :value="cronEmail"
      />
      <a v-if="!showEmail" href="#" @click.prevent="showEmail = true" class="my-2 d-flex">Update Email</a>
      <template v-else>
        <gg-text-field
          v-model="newEmail"
          v-validate="{ cron_email: accountUser }"
          class="mt-4"
          label="New Email"
          name="New Email"
          :error-messages="errors.collect('New Email')"
        />
        <gg-btn class="ml-0"
                tile
                :dark="canSubmit"
                :disabled="!canSubmit"
                :loading="loading"
                @click="updateEmailDialog">Update Email
        </gg-btn>
      </template>
    </v-form>
    <confirmation-dialog ref="dialog"
                         text="Are you certain that you do NOT wish to receive emails when a cron job runs?"
                         @confirmed="updateEmail"
    />
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { Validator } from 'vee-validate'
import { cronEmailValidator } from '@/helpers/validators'
import ConfirmationDialog from '@/components/Common/ConfirmationDialog'

export default {
  name: 'CronEmailForm',
  components: {
    ConfirmationDialog,
  },
  props: {
    accountUser: {
      required: true,
      type: String,
    },
  },
  data () {
    return {
      loading: false,
      newEmail: '',
      confirmDialog: false,
      showEmail: false
    }
  },
  computed: {
    ...mapGetters(['cronEmail']),
    canSubmit () {
      return !this.isLoading && this.cronEmail !== this.newEmail
    },
  },
  methods: {
    ...mapActions(['setCronEmail', 'getCronEmail', 'reportSuccess', 'reportError']),
    updateEmailDialog () {
      if (this.newEmail.length === 0) {
        this.$refs.dialog.open()
      } else {
        this.updateEmail()
      }
    },
    updateEmail () {
      this.storeNewEmail(this.newEmail)
    },
    async storeNewEmail (email) {
      const valid = await this.$validator.validateAll()

      if (!valid) { return }

      this.loading = true
      const data = {
        email,
        _username: this.$route.query.user
      }
      this.setCronEmail(data).then(
        () => {
          this.reportSuccess(`Cron Email updated to "${email}".`)
          this.loading = false
          this.reset()
        },
        error => {
          this.loading = false
          this.reportError(error)
        }
      )
    },
    reset () {
      this.newEmail = ''
      this.$nextTick(() => {
        this.$validator.reset()
      })
    }
  },
  created () {
    Validator.extend('cron_email', cronEmailValidator)
  }
}
</script>
